import { FirestoreService } from 'common/firebase';
import { ActionState, EventDetail } from "common/types";

export function getEventDataConverter() {
  return FirestoreService.instance.createDataConverter<EventDetail>((data) => ({
    ...data,
  }), (snapshot) => {
    const data = snapshot.data();
    return {
      id: snapshot.id,
      name: data.name,
      description: data.description,
      endDate: data.endDate?.toDate(),
      startDate: data.startDate?.toDate(),
      content: data.content,
      relatedShopLink: data.relatedShopLink?.trim(),
      disabled: !!data.disabled,
      verified: (() => {
        if (data.verified && typeof data.verified === 'boolean') {
          return !!data.verified;
        } else {
          return false;
        }
      })(),
      tags: (() => {
        if (data.tags && Array.isArray(data.tags)) {
          return data.tags as string[];
        } else {
          return [];
        }
      })(),
      image: data.image || null,
      lock: data.lock ? {
        event: data.lock.event,
        hash: data.lock.hash
      } : null
    }
  });
}

/**
 * Get or create event collection
 * @returns
 */
export function getEventCollection() {
  const dataConverter = getEventDataConverter();
  return FirestoreService.instance.getCollection('events', dataConverter);
}

/**
 * Get event detail
 * @param id Event ID
 */
export async function getEventDetail(id: string) {
  try {
    const collection = getEventCollection();
    const firestoreService = FirestoreService.instance;
    const docSnapshot = await firestoreService.getDocument(collection, id);

    if (docSnapshot.exists()) {
      return { state: ActionState.OK, data: docSnapshot.data() };
    } else {
      return { state: ActionState.NotFound, data: null };
    }
  } catch (error) {
    console.error('error', error);
    return { state: ActionState.ServerError, data: null };
  }
}